export const MENU_PAGE_STATS_TARGET = 'menu-page-stats';
export const MENU_PAGE_ACTIONS_TARGET = 'menu-page-actions';

export interface PageToolbarLayoutState {
    hasStats: Ref<boolean>;
}

export const PAGE_TOOLBAR_LAYOUT_KEY: InjectionKey<PageToolbarLayoutState> = Symbol('pageToolbarLayout');

export function providePageToolbarLayout(state: PageToolbarLayoutState) {
    provide(PAGE_TOOLBAR_LAYOUT_KEY, state);
}

export function usePageToolbarLayout() {
    return inject(PAGE_TOOLBAR_LAYOUT_KEY, null);
}
